export class SucursalModel{
	constructor(public id:MchSucursalesId,
		public vdireccion:string,
		public vtelefono:string,	
		public defCiudades:DefCiudades,
		public vcorreo:string,
		public nenviamail:number,		
		public nprincipal:number,
		public nestado:number,
		public bloquear:number,
		public vpostal : string,
		public deptoextranjero : string,
		public ciudadextranjero : string		 
		){}
}


export class MchSucursalesId{
	constructor(public cnumcont:string,public ctipid:string,public cnumid:string,public cidregter:string){}
}
export class DefCiudades{
	constructor(public id:DefCiudadesId, public vnombre:string){}
}
export class DefCiudadesId{
	constructor(public ccodigociudad:number, public ccodigodepto:string, public ccodigopais:string){}
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Tercero/Sucursal.model.ts